import React from "react";
import "./CustomerRanking.css";

interface Customer {
  id: number;
  name: string;
  date: string;
  customerId: string;
  amount: string;
  status: "Active" | "Pending" | "Declined";
}

const customers: Customer[] = [
  {
    id: 1,
    name: "Andre Collen",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$10,800.00",
    status: "Active",
  },
  {
    id: 2,
    name: "Samantha Blessed",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$9,500.00",
    status: "Active",
  },
  {
    id: 3,
    name: "Ayodele Mohamed",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$7,300.00",
    status: "Active",
  },
  {
    id: 4,
    name: "Nicole Nzubechi",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$5,500.00",
    status: "Active",
  },
  {
    id: 5,
    name: "Clarence Peters",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$0.00",
    status: "Pending",
  },
  {
    id: 6,
    name: "Sompto Daniels",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$0.00",
    status: "Pending",
  },
  {
    id: 7,
    name: "Henry Mclean",
    date: "August 8, 2023",
    customerId: "PAM-66382",
    amount: "$0.00",
    status: "Declined",
  },
];

const CustomerRanking: React.FC = () => {
  return (
    <div className="customer-ranking">
      <h3 className="customer-ranking-title">Customer Ranking</h3>
      <div className="customer-ranking-list">
        {customers.map((customer) => (
          <div key={customer.id} className="customer-ranking-item table-s">
            <div className="customer-ranking-info">
              <p className="customer-ranking-name">{customer.name}</p>
              <div className="customer-ranking__date-id">
                <p className="customer-ranking-date">{customer.date}</p>
                <p className="customer-ranking-id">{customer.customerId}</p>
              </div>
            </div>
            <div className="customer-ranking-details">
              <p className="customer-ranking-amount">{customer.amount}</p>
              <span
                className={`customer-ranking-status customer-ranking-status-${customer.status.toLowerCase()}`}
              >
                {customer.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerRanking;
